<template>
  <span>
    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <vs-button @click="backToPricingTiers" class="mr-4 float-right" color="primary" type="border">
          Back to pricing tiers
        </vs-button>
        <!-- <vs-button v-if="pricing_tier_details.is_active" @click.stop="onClickStatusChange('in-active')" class="mr-4 float-right" color="danger" type="filled">
          In-Active pricing tier
        </vs-button>
        <vs-button v-else @click.stop="onClickStatusChange('active')" class="mr-4 float-right" color="success" type="filled">
          Active pricing tier
        </vs-button> -->
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-3/5">
        <vx-card :title="pricing_tier_details.name">

          <div class="flex flex-wrap items-center mb-base">
            <vs-avatar :src="pricing_tier_details.avatar" size="70px" class="mr-4 mb-4" />
            <div>
              <vs-button @click="toggleShow" class="mr-4 sm:mb-0 mb-2">Upload avatar</vs-button>
              <p class="text-sm mt-2">Allowed JPG or PNG.</p>
            </div>
            <my-upload field="img" @crop-success="cropSuccess" v-model="show" :width="50" :height="50" lang-type="en"
              :params="params" :headers="headers" img-format="png"></my-upload>
          </div>

          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickSubmitForm)" autocomplete="off" id="pricing-tier-form">

              <div class="vx-row mb-3">
                <div class="vx-col w-full md:mb-0">
                  <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                    <small class="label">Package name</small>
                    <vs-input v-model="pricing_tier_details.name" name="name" class="w-full required" label=""
                      :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-3">
                <div class="vx-col w-full md:mb-0">
                  <ValidationProvider vid="description" name="description" rules="required" v-slot="{ errors }">
                    <small class="label">Description</small>
                    <vs-input v-model="pricing_tier_details.description" name="description" class="w-full required"
                      label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                      val-icon-pack="feather" />
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-3">
                <div class="vx-col w-1/2" v-for="(charge, index) in pricing_tier_details.charges" :key="index">
                  <vx-card :title="`${charge.currency} Pricing`" cardBorder noShadow class="my-4">
                    <div class="vx-row mb-3">
                      <div class="vx-col w-1/2 md:mb-0">
                        <ValidationProvider :vid="`${index}_setup_charge`" :name="`${index}_setup_charge`"
                          rules="required" v-slot="{ errors }">
                          <small class="label">Setup charge ({{ charge.currency }})</small>
                          <vs-input v-model="charge.setup_charge" :name="`${index}_setup_charge`" class="w-full"
                            label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather" type="number" step="0.01" />
                        </ValidationProvider>
                      </div>
                      <div class="vx-col w-1/2 md:mb-0">
                        <ValidationProvider :vid="`${index}_price`" :name="`${index}_price`" rules="required"
                          v-slot="{ errors }">
                          <small class="label">Package price ({{ charge.currency }}) PCM</small>
                          <vs-input v-model="charge.price" :name="`${index}_price`" class="w-full" label=""
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather" type="number" step="0.01" />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-row mb-3">
                      <div class="vx-col w-1/2">
                        <ValidationProvider :vid="`${index}_staffs_block`" :name="`${index}_staffs_block`"
                          rules="required" v-slot="{ errors }">
                          <small class="label">Staff block</small>
                          <vs-input v-model="charge.staffs_block" :name="`${index}_staffs_block`" class="w-full"
                            label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather" type="number" step="0.01" />
                        </ValidationProvider>
                      </div>
                      <div class="vx-col w-1/2">
                        <ValidationProvider :vid="`${index}_additional_staffs_block`"
                          :name="`${index}_additional_staffs_block`" rules="required" v-slot="{ errors }">
                          <small class="label">Additional staff block</small>
                          <vs-input v-model="charge.additional_staffs_block" :name="`${index}_additional_staffs_block`"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01" />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-row mb-3">
                      <div class="vx-col w-1/2">
                        <ValidationProvider :vid="`${index}_additional_staffs_price`"
                          :name="`${index}_additional_staffs_price`" rules="required" v-slot="{ errors }">
                          <small class="label">Additional staff block price ({{ charge.currency }}) PCM</small>
                          <vs-input v-model="charge.additional_staffs_price" :name="`${index}_additional_staffs_price`"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01" />
                        </ValidationProvider>
                      </div>
                      <div class="vx-col w-1/2">
                        <ValidationProvider :vid="`${index}_customer_portal_price`"
                          :name="`${index}_customer_portal_price`" rules="required" v-slot="{ errors }">
                          <small class="label">Customer portal price ({{ charge.currency }})</small>
                          <vs-input v-model="charge.customer_portal_price" :name="`${index}_customer_portal_price`"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01" />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-row mb-3">
                      <div class="vx-col w-1/2">
                        <ValidationProvider :vid="`${index}_supplier_portal_price`"
                          :name="`${index}_supplier_portal_price`" rules="required" v-slot="{ errors }">
                          <small class="label">Supplier portal price ({{ charge.currency }})</small>
                          <vs-input v-model="charge.supplier_portal_price" :name="`${index}_supplier_portal_price`"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01" />
                        </ValidationProvider>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <small class="label">Is this a free tier?</small>
                  <vs-switch class="mt-3 w-16" v-model="pricing_tier_details.is_free_tier" icon-pack="feather"
                    vs-icon-on="icon-check-circle" vs-icon-off="icon-slash">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </div>
              </div>

              <!-- <div class="vx-row mb-3">
                <div class="vx-col w-full md:mb-0">
                  <ValidationProvider vid="items" name="items" rules="" v-slot="{ errors }">
                    <small class="label">Pricing tier items</small>
                    <v-select :clearable="false" placeholder="" v-model="pricing_tier_details.items" :reduce="option => option.id"
                              label="name" :options="pricing_tier_items" :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple :closeOnSelect="false"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div> -->

              <div class="vx-row mt-8 font-bold mb-3">
                <div class="vx-col" style="width: 10%;">
                  <vs-checkbox @input="onClickSelectAllItems()" v-model="isSelectAll">Select All</vs-checkbox>
                </div>
                <div class="vx-col" style="width: 30%;">
                  Pricing tier item name
                </div>
                <div class="vx-col" style="width: 10%;">
                  Is unlimited?
                </div>
                <div class="vx-col" style="width: 18%;">
                  Allowance
                </div>
                <div class="vx-col" style="width: 10%;">
                  Time based allowance
                </div>
                <div class="vx-col" style="width: 22%;">
                  Duration (Days)
                </div>
              </div>
              <div class="vx-row" v-for="(item, indextr) in pricing_tier_items" :key="indextr">
                <div class="vx-col" style="width: 10%;">
                  <vs-checkbox class="mt-3" v-model="pricing_tier_items[indextr].is_active"></vs-checkbox>
                </div>
                <div class="vx-col" style="width: 30%;">
                  <vs-input class="w-full mb-2" readonly v-model="pricing_tier_items[indextr].name"></vs-input>
                </div>
                <div class="vx-col" style="width: 10%;">
                  <vs-switch class="mt-3" v-model="pricing_tier_items[indextr].is_unlimited"
                    v-if="pricing_tier_items[indextr].is_active" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </div>
                <div class="vx-col" style="width: 18%;">
                  <vs-input class="w-full mb-2" v-model="pricing_tier_items[indextr].quantity"
                    v-if="!pricing_tier_items[indextr].is_unlimited && pricing_tier_items[indextr].is_active"></vs-input>
                </div>
                <div class="vx-col" style="width: 10%;">
                  <vs-switch class="mt-3" v-model="pricing_tier_items[indextr].is_validity_required"
                    v-if="pricing_tier_items[indextr].is_active && !pricing_tier_items[indextr].is_unlimited"
                    icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </div>
                <div class="vx-col" style="width: 22%;">
                  <vs-input class="w-full mb-2" v-model="pricing_tier_items[indextr].duration"
                    v-if="pricing_tier_items[indextr].is_validity_required && pricing_tier_items[indextr].is_active && !pricing_tier_items[indextr].is_unlimited"></vs-input>
                </div>
              </div>

              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
                <vs-button @click="refreshData" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
              </div>

            </form>
          </ValidationObserver>
        </vx-card>
      </div>
      <div class="vx-col w-2/5">
        <vx-card title="Preview">
          <pricing-tier-card-view :pricing_details="pricing_tier_details" />
        </vx-card>
      </div>
    </div>
  </span>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const PricingRepository = RepositoryFactory.get('pricing')
const FileRepository = RepositoryFactory.get('file')
import PricingTierCardView from "@/views/pages/pricing-tiers/PricingTierCardView";
import ErrorMessages from "@/mixins/ErrorMessages";
import SuccessMessage from "@/mixins/SuccessMessage";
import vSelect from 'vue-select'
import myUpload from 'vue-image-crop-upload/upload-2.vue';
import Cookies from "js-cookie";


export default {
  name: "PricingTierView",
  mixins: [ErrorMessages, SuccessMessage],
  components: {
    'v-select': vSelect,
    'my-upload': myUpload,
    PricingTierCardView,
  },
  data() {
    return {
      id: '',
      pricing_tier_details: {
        avatar: 'https://picsum.photos/200',
        charges: [

        ]
      },
      pricing_tier_items: [],
      showCropper: false,
      show: false,
      params: {
        token: Cookies.get('current_user_token'),
        name: 'avatar'
      },
      headers: {
        authorization: 'Bearer ' + Cookies.get('current_user_token'),
      },
      isSelectAll: false
    }
  },
  async mounted() {
    this.id = this.$route.params.id
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      await this.fetchPricingTierDetails()
      await this.fetchPricingItems()
    },
    // fetch pricing tier details
    async fetchPricingTierDetails() {
      await this.$vs.loading({
        container: '#pricing-tier-form',
        scale: 0.50
      });
      try {
        const { data } = (await PricingRepository.getPricingTierDetails(this.id)).data
        this.pricing_tier_details = data
        const currency_list = ['GBP', 'USD', 'EUR', 'AUD', 'THB']
        this.pricing_tier_details.charges = currency_list.map((x) => {
          const find = this.pricing_tier_details.charges.find((y) => y.currency === x)
          if (find) {
            return find
          } else {
            return {
              currency: x,
              setup_charge: 0,
              price: 0,
              staffs_block: 0,
              additional_staffs_block: 0,
              additional_staffs_price: 0,
              customer_portal_price: 0,
              supplier_portal_price: 0
            }
          }
        })
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#pricing-tier-form > .con-vs-loading')
    },

    // fetch pricing tier items array
    async fetchPricingItems() {
      try {
        const { data } = (await PricingRepository.getPricingItems()).data
        this.pricing_tier_items = data.map((x) => {
          const find = this.pricing_tier_details.items.find((y) => y.id === x.id)
          console.log('find', find);
          if (find) {
            x.is_active = true
            x.quantity = find.pivot.quantity
            x.is_unlimited = find.pivot.is_unlimited
            x.is_validity_required = find.pivot.is_validity_required
            x.duration = find.pivot.duration
          } else {
            x.is_active = false
            x.quantity = null
            x.is_unlimited = false
            x.is_validity_required = false
            x.duration = 0
          }
          return x
        })
        this.isSelectAll = this.pricing_tier_items.every((x) => x.is_active)

      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },

    // update pricing tier details
    async onClickSubmitForm() {
      await this.$vs.loading({
        container: '#pricing-tier-form',
        scale: 0.50
      });
      try {
        // data mapping with two decimal places
        let payload = {}
        Object.assign(payload, this.pricing_tier_details)
        Object.assign(payload.items, this.pricing_tier_items)
        payload.items = payload.items.filter((x) => x.is_active).map((x) => ({ id: x.id, is_unlimited: x.is_unlimited, quantity: x.quantity ? x.quantity : 0, is_validity_required: x.is_validity_required, duration: x.duration }))

        payload.charges = this.pricing_tier_details.charges.map((x) => {
          let tier = {}
          tier.setup_charge = Number(x.setup_charge).toFixed(2)
          tier.price = Number(x.price).toFixed(2)
          tier.staffs_block = x.staffs_block
          tier.additional_staffs_block = x.additional_staffs_block
          tier.additional_staffs_price = Number(x.additional_staffs_price).toFixed(2)
          tier.customer_portal_price = Number(x.customer_portal_price).toFixed(2)
          tier.supplier_portal_price = Number(x.supplier_portal_price).toFixed(2)
          tier.currency = x.currency
          return tier
        })

        await PricingRepository.updatePricingTier(this.id, payload)
        this.showSuccessMessage('Pricing tier updated successfully')
        await this.refreshData()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#pricing-tier-form > .con-vs-loading')
    },

    // upload avatar base64 and get image url
    async cropSuccess(imgDataUrl, field) {
      try {
        const data = await FileRepository.uploadBase64File({
          file_name: Date.now() + '',
          path: 'pricing/avatar',
          file: imgDataUrl
        })
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.pricing_tier_details.avatar = imgDataUrl;
    },

    // open avatar upload popup
    toggleShow() {
      this.show = !this.show;
    },

    // back to tiers
    backToPricingTiers() {
      this.$router.push('/pages/pricing-tiers')
    },
    async onClickStatusChange(status) {
      await this.$vs.loading({
        container: '#pricing-tier-form',
        scale: 0.50
      });
      try {
        await PricingRepository.statusChangePricingTier(this.id, status)
        await this.fetchPricingTierDetails()
        this.showSuccessMessage('Pricing tier status changed successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#pricing-tier-form > .con-vs-loading')
    },
    onClickSelectAllItems() {
      this.pricing_tier_items = this.pricing_tier_items.map((x) => {
        x.is_active = this.isSelectAll
        return x
      })
    }
  },
}
</script>

<style scoped></style>
